import React from 'react';
import { getFullDateRange } from './GlucoseStats';

const formatDateForDisplay = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

function DateRangeDisplay({ dateRange, onDateRangeChange, onClear, entries }) {
  const fullRange = getFullDateRange(entries);
  const isShowingAllTime = dateRange.start === fullRange.start && 
                          dateRange.end === fullRange.end;

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-3 border border-gray-100">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {/* Date Range Inputs */}
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center">
            <label className="font-medium text-gray-700 mr-2 text-xs">From</label>
            <input
              type="date"
              name="start"
              value={dateRange.start}
              onChange={onDateRangeChange}
              className="text-xs p-1.5 border rounded hover:border-teal-500 focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-colors"
            />
          </div>
          <div className="flex items-center">
            <label className="font-medium text-gray-700 mr-2 text-xs">To</label>
            <input
              type="date"
              name="end"
              value={dateRange.end}
              onChange={onDateRangeChange}
              className="text-xs p-1.5 border rounded hover:border-teal-500 focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-colors"
            />
          </div>
        </div>

        {/* Current Range Display and Reset Button */}
        <div className="flex items-center gap-3">
          {dateRange.start && dateRange.end && (
            <div className="text-xs text-gray-600">
              {formatDateForDisplay(dateRange.start)} - {formatDateForDisplay(dateRange.end)}
            </div>
          )}
          <button
            onClick={onClear}
            disabled={isShowingAllTime}
            className={`text-xs font-medium px-2 py-1 rounded transition-colors ${
              isShowingAllTime 
                ? 'text-gray-400 cursor-not-allowed bg-gray-50' 
                : 'text-teal-700 hover:text-teal-500 hover:bg-teal-50'
            }`}
          >
            {isShowingAllTime ? 'All data' : 'Reset'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DateRangeDisplay;
